export enum DealTypes {
	OpenAuction = 'Open Auction',
	PreferredDeal = 'Preferred Deal',
}

export type DealType = DealTypes.OpenAuction | DealTypes.PreferredDeal;
